exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notFound___1K0sz{text-align:center;padding:50px 0;font-size:25px}", "", {"version":3,"sources":["/./src/components/src/components/src/components/NotFound.scss"],"names":[],"mappings":"AAGA,kBACE,kBAAmB,AACnB,eAAkB,AAClB,cAAgB,CACjB","file":"NotFound.scss","sourcesContent":["@import '../theme/variables.scss';\n@import '../theme/mixins.scss';\n\n.notFound {\n  text-align: center;\n  padding: 50px 0px;\n  font-size: 25px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"notFound": "notFound___1K0sz"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=2&sourceMap&localIdentName=[local]___[hash:base64:5]!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded&sourceMap!./src/components/NotFound.scss
// module id = 548
// module chunks = 0